export default __webpack_public_path__ + "static/media/dulces_side.a4cd22a5.jpg";